export const ISO8601_REGEX =
  // eslint-disable-next-line no-useless-escape
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[\+\-]\d{2}:\d{2})?$/;
